module.exports = __webpack_public_path__ + "media/organizations/htwk-7b4c6f50.svg";